import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_API_URL;
  const [profile, setProfile] = useState({});

  const handleNavigation = (path) => {
    navigate(path);
  };

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(`${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await profileRes.json();
      setProfile(res.users);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-section">
          <h2 className="footer-logo">
            {profile?.profilePic ? (
              <img
                src={`${url}/uploads/profile/${profile.profilePic}`}
                alt="Logo"
                style={{ height: "40px", objectFit: "contain" }}
              />
            ) : (
              profile?.orignal_logoname || "Radical Sports India"
            )}
          </h2>
          <p>Radical Sports India – Premier Roller Skating Academy with national-level training and equipment.</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/radicalskatingacademy" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com/RadicalSkatingAcademy" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com/@radicalsportsacademy5024" target="_blank" rel="noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li onClick={() => handleNavigation("/")}>Home</li>
            <li onClick={() => handleNavigation("/course")}>Courses</li>
            <li onClick={() => handleNavigation("/equipments")}>Equipments</li>
            <li onClick={() => handleNavigation("/admission-form")}>Admission</li>
            <li onClick={() => handleNavigation("/about")}>About Radical</li>
            <li onClick={() => handleNavigation("/contact")}>Contact Radical</li>
            <li
              onClick={() => {
                window.location.href = "https://business.100billionoms.com";
              }}
              style={{ cursor: "pointer" }}
            >
              Admin Login
            </li>
          </ul>

        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            <li onClick={() => handleNavigation("/refund-policy")}>Refund Policy</li>
            <li onClick={() => handleNavigation("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => handleNavigation("/rules-and-regulations")}>Rules & Regulations</li>
            <li onClick={() => handleNavigation("/shipping-and-delivery")}>Shipping Policy</li>
            <li onClick={() => handleNavigation("/enquiry-form-form")}>Enquiry</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p><strong>Phone:</strong> +91-765464545</p>
          <p><strong>Email:</strong> Info@radicalsportsindia.com</p>
          <p><strong>Address:</strong></p>
          <ul>
            <li>
              Radical Sports Academy, 2nd Floor, Ajanta Shopping Centre, 225, Daftary Road, opp. Surbhi Sweets, near Railway Station, Malad East, Mumbai, Maharashtra 400097
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {currentYear} All rights reserved. Powered by <a href="https://100billiontech.com/">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
